import invoice from './invoice';
export default invoice;